import { gql, useMutation } from '@apollo/client'
import { ARTIFACT_LABEL } from '@jusbrasil-web/docview/core'

import {
  EditTextCommentMutation,
  EditTextCommentMutationVariables,
} from '../components/__generated__/mutations.graphql'
import { EditTextComment } from '../components/mutations'
import {
  UseEditTextComment_CommentFragment,
  UseEditTextComment_DocumentFragment,
} from './__generated__/use-edit-text-comment.graphql'

export type UseEditTextCommentProps = {
  document: UseEditTextComment_DocumentFragment
  comment: UseEditTextComment_CommentFragment
  commentText: string
}

export type UseEditTextCommentReturn = {
  loading: boolean
  editTextComment: () => Promise<void>
}

export function useEditTextComment({
  document,
  commentText,
  comment,
}: UseEditTextCommentProps): UseEditTextCommentReturn {
  const { docId, artifact } = document
  const [mutate, { loading }] = useMutation<
    EditTextCommentMutation,
    EditTextCommentMutationVariables
  >(EditTextComment, {
    update(cache, { data: mutate }) {
      cache.modify<{ text: string }>({
        id: cache.identify(comment),
        fields: {
          text() {
            return mutate?.editTextDocument?.document?.text || ''
          },
        },
      })
    },
  })

  return {
    async editTextComment() {
      const input = {
        docId: comment?.id,
        artifact: ARTIFACT_LABEL.COMENTARIO,
        text: commentText,
        parentDocId: docId,
        parentDocArtifact: artifact,
      }
      await mutate({ variables: { input } })
    },
    loading,
  }
}

useEditTextComment.fragments = {
  document: gql`
    fragment UseEditTextComment_document on Document {
      docId
      artifact
    }
  `,
  comment: gql`
    fragment UseEditTextComment_comment on DocumentComment {
      id
    }
  `,
}
